import React, { useEffect, useState } from "react";
import {
  DivHeader,
  Header,
  Input,
  Section,
  SpanHeader,
  Subtitulo,
  Td,
  Titulo,
  TituloDiv,
  Value,
  Container,
  Td2,
  Tr,
} from "./styles";
import { useEntidade } from "../../Hooks/EntidadeHook";
import { IssqnInformado, useIssqn } from "../../Storage/issqn";
import { FormataData } from "../../Utils/FormataData";
import { FormataMoeda } from "../../Utils/FormataMoeda";
import { GuiaCode } from "./BarCode";
import { cpfMask } from "../../Utils/mascaras";
import axios from "axios";
import { api_pix } from "../../Utils/Urls";

interface Props {
  issqn: IssqnInformado;
  modo?: "preview" | "print";
}



type PixData = {
  qrBase64: string;
  pixCopiaECola: string;
};

export const Boleto = ({ issqn, modo = "preview" }: Props) => {
  
  const { entidade } = useEntidade();
  const { empresaFocus } = useIssqn();

  const [pixData, setPixData] = useState<PixData | null>(null);
  const [loadingPix, setLoadingPix] = useState(false);
  const [erroPix, setErroPix] = useState("");

  const isPreview = modo === "preview";
  const isPrint = modo === "print";

  useEffect(() => {
    if (issqn?.ID) {
      gerarPix();
    }
  }, [issqn?.ID]);

  async function gerarPix(): Promise<void> {
    try {
      setLoadingPix(true);
      setErroPix("");
      setPixData(null);

      const { data } = await axios.post(api_pix, {
        id_entidade: entidade.id,
        valor: issqn.ISSQN,
        dataDeVencimento: String(issqn.VENCIMENTO).substring(0, 10),
        cod_barras: issqn.CODBARRA,
        nome: empresaFocus.DESCRICAO,
        cpf_cnpj: empresaFocus.CNPJ || empresaFocus.CPF,
        carne: issqn.CHAVE,
      });

      if (!data?.status || !data?.data) {
        setErroPix("Não foi possível gerar o PIX.");
        return;
      }

      setPixData({
        qrBase64: data.data.qrBase64?.startsWith("data:image")
          ? data.data.qrBase64
          : `data:image/png;base64,${data.data.qrBase64}`,
        pixCopiaECola: data.data.pixCopiaECola,
      });
    } catch (error) {
      console.error("Erro ao gerar PIX:", error);
      setErroPix("Erro ao gerar PIX.");
    } finally {
      setLoadingPix(false);
    }
  }

  const documento =
    empresaFocus.CNPJ && empresaFocus.CNPJ.length === 14
      ? empresaFocus.CNPJ
      : cpfMask(empresaFocus.CPF);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: isPreview ? "18px" : "8px",
        background: isPreview ? "#e5e7eb" : "#f3f5f7",
      }}
    >
      <Container
        style={{
          maxWidth: isPreview ? "980px" : "930px",
          width: "100%",
          background: "#fff",
          borderRadius: isPreview ? "14px" : "10px",
          boxShadow: isPreview
            ? "0 8px 28px rgba(0,0,0,0.12)"
            : "0 4px 14px rgba(0,0,0,0.06)",
          overflow: "hidden",
          border: "1px solid #dde3e8",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(135deg, rgba(0,98,155,1) 0%, rgba(0,69,110,1) 100%)",
            padding: isPreview ? "16px 22px" : "10px 14px",
          }}
        >
          <Header style={{ margin: 0, alignItems: "center" }}>
            <img
              src={entidade.logo}
              alt="Logo"
              style={{
                width: isPreview ? "66px" : "58px",
                height: isPreview ? "74px" : "66px",
                objectFit: "contain",
                background: "#fff",
                borderRadius: "8px",
                padding: isPreview ? "6px" : "4px",
                flexShrink: 0,
              }}
            />
            <DivHeader style={{ gap: isPreview ? "4px" : "2px" }}>
              <SpanHeader
                style={{
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: isPreview ? "16px" : "14px",
                  lineHeight: 1.2,
                }}
              >
                MUNICÍPIO DE{" "}
                {entidade.titulo?.toUpperCase().replace("PREFEITURA -", "")}
              </SpanHeader>
              <SpanHeader
                style={{
                  color: "#eaf6ff",
                  fontSize: isPreview ? "12px" : "11px",
                  lineHeight: 1.15,
                }}
              >
                SECRETARIA MUNICIPAL DA FAZENDA
              </SpanHeader>
              <SpanHeader
                style={{
                  color: "#eaf6ff",
                  fontSize: isPreview ? "12px" : "11px",
                  lineHeight: 1.15,
                }}
              >
                NOTA FISCAL DE SERVIÇOS ELETRÔNICA - NFS-e
              </SpanHeader>
            </DivHeader>
          </Header>
        </div>

        <TituloDiv
          style={{
            padding: isPreview ? "16px 18px 8px 18px" : "10px 14px 4px 14px",
            borderBottom: "1px solid #e8edf1",
          }}
        >
          <Titulo
            style={{
              fontSize: isPreview ? "24px" : "20px",
              fontWeight: 800,
              color: "#153243",
              lineHeight: 1.1,
            }}
          >
            Guia de Recolhimento
          </Titulo>
          <Subtitulo
            style={{
              fontSize: isPreview ? "14px" : "12px",
              color: "#5b6b79",
              marginTop: "2px",
            }}
          >
            ISS - Imposto sobre Serviços
          </Subtitulo>
        </TituloDiv>

        <div style={{ padding: isPreview ? "16px 18px" : "10px 12px" }}>
          <Section style={{ marginBottom: isPreview ? "10px" : "6px" }}>
            <Input
              width={"80vw"}
              style={{
                width: "100%",
                borderRadius: "8px",
                background: "#f8fafc",
                border: "1px solid #e5e7eb",
                padding: isPreview ? "10px 12px" : "8px 10px",
                boxSizing: "border-box",
                fontSize: isPreview ? "12px" : "11px",
              }}
            >
              RAZÃO SOCIAL
              <Value
                style={{
                  fontSize: isPreview ? "18px" : "14px",
                  fontWeight: 700,
                  wordBreak: "break-word",
                  lineHeight: 1.2,
                }}
              >
                {empresaFocus.DESCRICAO}
              </Value>
            </Input>
          </Section>

          <Section
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: isPreview ? "10px" : "6px",
              marginBottom: isPreview ? "12px" : "8px",
            }}
          >
            {(empresaFocus.CNPJ || empresaFocus.CPF) && (
              <Input
                width={"40vw"}
                style={{
                  width: "100%",
                  margin: 0,
                  borderRadius: "8px",
                  background: "#f8fafc",
                  border: "1px solid #e5e7eb",
                  padding: isPreview ? "10px 12px" : "8px 10px",
                  boxSizing: "border-box",
                  fontSize: isPreview ? "12px" : "11px",
                }}
              >
                CPF/CNPJ
                <Value style={{ wordBreak: "break-word", fontSize: isPreview ? "15px" : "13px" }}>
                  {documento}
                </Value>
              </Input>
            )}

            <Input
              width={"40vw"}
              style={{
                width: "100%",
                margin: 0,
                borderRadius: "8px",
                background: "#f8fafc",
                border: "1px solid #e5e7eb",
                padding: isPreview ? "10px 12px" : "8px 10px",
                boxSizing: "border-box",
                fontSize: isPreview ? "12px" : "11px",
              }}
            >
              INSCRIÇÃO MUNICIPAL
              <Value style={{ wordBreak: "break-word", fontSize: isPreview ? "15px" : "13px" }}>
                {empresaFocus.INSCR}
              </Value>
            </Input>
          </Section>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: isPreview ? "12px" : "8px",
              marginBottom: isPreview ? "12px" : "8px",
            }}
          >
            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#fff",
                minWidth: 0,
              }}
            >
              <div
                style={{
                  padding: isPreview ? "10px 12px" : "7px 10px",
                  background: "#f8fafc",
                  fontWeight: 700,
                  color: "#243746",
                  borderBottom: "1px solid #e5e7eb",
                  fontSize: isPreview ? "15px" : "12px",
                }}
              >
                Dados da Guia
              </div>

              <Section style={{ padding: isPreview ? "10px 12px" : "6px 8px" }}>
                <div style={{ width: "100%", minWidth: 0 }}>
                  <Tr>
                    <Td style={{ fontSize: isPreview ? "14px" : "11px" }}>Competência</Td>
                    <Td value={true} style={{ fontSize: isPreview ? "14px" : "11px" }}>
                      {issqn.PERIODO}
                    </Td>
                  </Tr>
                  <Tr>
                    <Td style={{ fontSize: isPreview ? "14px" : "11px" }}>Valor</Td>
                    <Td value={true} style={{ fontSize: isPreview ? "14px" : "11px" }}>
                      {FormataMoeda(issqn.ISSQN)}
                    </Td>
                  </Tr>
                 <Tr>
  <Td style={{ fontSize: isPreview ? "14px" : "11px" }}>
    Vencimento
  </Td>

  <Td
    value={true}
    style={{
      fontSize: isPreview ? "14px" : "11px",
      color: "#b42318", // 🔴 vermelho elegante
      fontWeight: 800,
      background: "#fff1f1",
     
      display: "inline-block",
    }}
  >
    {FormataData(issqn.VENCIMENTO)}
  </Td>
</Tr>
                  <Tr>
                    <Td style={{ fontSize: isPreview ? "14px" : "11px" }}>Guia</Td>
                    <Td value={true} style={{ fontSize: isPreview ? "14px" : "11px" }}>
                      {issqn.ID}
                    </Td>
                  </Tr>
                </div>
              </Section>
            </div>

            <div
              style={{
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#fff",
                minWidth: 0,
              }}
            >
              <div
                style={{
                  padding: isPreview ? "10px 12px" : "7px 10px",
                  background: "#f8fafc",
                  fontWeight: 700,
                  color: "#243746",
                  borderBottom: "1px solid #e5e7eb",
                  fontSize: isPreview ? "15px" : "12px",
                }}
              >
                Resumo Financeiro
              </div>

              <div style={{ padding: isPreview ? "10px 12px" : "6px 8px" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "fixed",
                    fontSize: isPreview ? "13px" : "11px",
                  }}
                >
                  <tbody>
                    {[
                      ["Base de cálculo", FormataMoeda(issqn.BASE)],
                      ["ISSQN", FormataMoeda(issqn.ISSQN)],
                      ["ISS Apurado", FormataMoeda(issqn.ISSQN)],
                      ["Correção Monetária", FormataMoeda(0)],
                      ["Juros", FormataMoeda(0)],
                      ["Multa", FormataMoeda(0)],
                    ].map(([label, value]) => (
                      <tr key={label}>
                        <Td2
                          style={{
                            textAlign: "left",
                            width: "56%",
                            padding: isPreview ? "5px 8px 5px 0" : "3px 6px 3px 0",
                            wordBreak: "break-word",
                            fontSize: isPreview ? "14px" : "11px",
                            lineHeight: 1.15,
                          }}
                        >
                          {label}
                        </Td2>
                        <Td2
                          value={true}
                          style={{
                            textAlign: "right",
                            width: "44%",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            fontSize: isPreview ? "14px" : "11px",
                            lineHeight: 1.15,
                          }}
                        >
                          {value}
                        </Td2>
                      </tr>
                    ))}

                    <tr>
                      <Td2
                        style={{
                          textAlign: "left",
                          fontWeight: 800,
                          color: "#0f5132",
                          paddingTop: isPreview ? "8px" : "6px",
                          borderTop: "1px solid #dbe5ea",
                          fontSize: isPreview ? "15px" : "11px",
                        }}
                      >
                        Total
                      </Td2>
                      <Td2
                        value={true}
                        style={{
                          textAlign: "right",
                          fontWeight: 800,
                          color: "#0f5132",
                          paddingTop: isPreview ? "8px" : "6px",
                          borderTop: "1px solid #dbe5ea",
                          fontSize: isPreview ? "15px" : "11px",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {FormataMoeda(issqn.ISSQN)}
                      </Td2>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div
            style={{
              border: "1px solid #cfe2f3",
              background: "linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)",
              borderRadius: "10px",
              padding: isPreview ? "12px" : "8px",
              marginBottom: isPreview ? "12px" : "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "8px",
                marginBottom: isPreview ? "10px" : "6px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: isPreview ? "20px" : "14px",
                    fontWeight: 800,
                    color: "#0b4f82",
                    lineHeight: 1.1,
                  }}
                >
                  Pagamento via PIX
                </div>
                <div
                  style={{
                    color: "#48606f",
                    fontSize: isPreview ? "12px" : "10px",
                    lineHeight: 1.15,
                  }}
                >
                  Escaneie o QR Code ou utilize o código PIX abaixo
                </div>
              </div>

              <div
                style={{
                  background: "#0b4f82",
                  color: "#fff",
                  padding: isPreview ? "6px 12px" : "4px 9px",
                  borderRadius: "999px",
                  fontWeight: 700,
                  fontSize: isPreview ? "14px" : "11px",
                  whiteSpace: "nowrap",
                }}
              >
                {FormataMoeda(issqn.ISSQN)}
              </div>
            </div>

            {loadingPix && (
              <div
                style={{
                  padding: isPreview ? "16px" : "10px",
                  textAlign: "center",
                  color: "#4b5563",
                  background: "#fff",
                  borderRadius: "8px",
                  border: "1px dashed #cbd5e1",
                  fontSize: isPreview ? "14px" : "11px",
                }}
              >
                Gerando QR Code do PIX...
              </div>
            )}

            {!loadingPix && erroPix && (
              <div
                style={{
                  padding: isPreview ? "16px" : "10px",
                  textAlign: "center",
                  color: "#b42318",
                  background: "#fff5f5",
                  borderRadius: "8px",
                  border: "1px solid #fecaca",
                  fontSize: isPreview ? "14px" : "11px",
                }}
              >
                {erroPix}
              </div>
            )}

            {!loadingPix && !erroPix && pixData && (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isPreview
                    ? "120px minmax(0, 1fr)"
                    : "88px minmax(0, 1fr)",
                  gap: isPreview ? "12px" : "8px",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    background: "#fff",
                    borderRadius: "8px",
                    border: "1px solid #dbeafe",
                    padding: isPreview ? "8px" : "6px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: isPreview ? "120px" : "88px",
                  }}
                >
                  <img
                    src={pixData.qrBase64}
                    alt="QR Code PIX"
                    style={{
                      width: isPreview ? "100px" : "72px",
                      height: isPreview ? "100px" : "72px",
                      objectFit: "contain",
                      display: "block",
                    }}
                  />
                </div>

                <div
                  style={{
                    background: "#fff",
                    borderRadius: "8px",
                    border: "1px solid #dbeafe",
                    padding: isPreview ? "12px" : "8px",
                    minWidth: 0,
                    minHeight: isPreview ? "120px" : "88px",
                  }}
                >
                  <div
                    style={{
                      fontSize: isPreview ? "12px" : "10px",
                      fontWeight: 700,
                      color: "#4b5563",
                      marginBottom: "4px",
                    }}
                  >
                    PIX COPIA E COLA
                  </div>

                  <div
                    style={{
                      wordBreak: "break-all",
                      overflowWrap: "anywhere",
                      background: "#f8fafc",
                      border: "1px solid #e5e7eb",
                      borderRadius: "6px",
                      padding: isPreview ? "10px" : "6px",
                      fontSize: isPreview ? "11px" : "9px",
                      color: "#243746",
                      lineHeight: 1.25,
                    }}
                  >
                    {pixData.pixCopiaECola}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            style={{
              borderTop: "1px solid #e5e7eb",
              paddingTop: isPreview ? "12px" : "8px",
            }}
          >
            <div
              style={{
                fontSize: isPreview ? "13px" : "11px",
                color: "#475467",
                fontWeight: 700,
                marginBottom: "4px",
              }}
            >
              Código de barras para pagamento
            </div>

            <div
              style={{
                background: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                padding: isPreview ? "12px" : "8px",
                overflow: "hidden",
              }}
            >
              <GuiaCode codigo={issqn.CODBARRA ? issqn.CODBARRA : ""} />
            </div>
          </div>
        </div>

        <style>
          {`
            @media print {
              html, body {
                margin: 0 !important;
                padding: 0 !important;
                background: #fff !important;
              }

              body * {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }

              @page {
                size: A4 portrait;
                margin: 6mm;
              }
            }
          `}
        </style>
      </Container>
    </div>
  );
};